export type TDcfSliceState = {
    vesselListDcf: TVesselListDcf | null;
    summaryDcf: TSummaryDcf | null;
    dcfValueState: TDcfState | null;
};

export interface IDcfVessel {
    imoNumber: number;
    name: string;
    sectorId: number
    sectorName: string
    size: number
    sizeUnit: string
    age: number
    yearOfDelivery: number,
    owner: string,
    gearTankCargoContainment: string,
    fuelSystem: string,
}


export type TSummaryDcf = {
    dataList: TSummaryDcfItem[] | null;
    infoNote: string;
    loading: boolean;
    loadingError: Error | null;
}

export type TSummaryDcfItem = {
    sector: string
    ships: number
    averageSize: number
    sizeUnit: string
    averageAge: number
    dcfValue: number
};


export type TVesselListDcf = {
    dataList: TVesselDcf[] | null;
    loading: boolean;
    loadingError: Error | null;
}

export type TVesselDcf = {
    imoNumber: number | null;
    financialMetrics: TFinancialMetrics | null;
    financeProjectAssumptions: TFinanceProjectAssumptions | null;

};

export type TFinancialMetrics = {
    equityIrr: number | null,
    equityNpv: number | null,
    projectIrr: number | null,
    projectNpv: number | null,
    ltvAtFinance: number | null,
    equityDcfValue: number | null,
    projectDcfValue: number | null
};

export type TFinanceProjectAssumptions = {
    wacc: number,
    onHire: number,
    period: number,
    balloon: number,
    salePrice: number | null,
    salePriceAge: number | null,
    averageOpex: number | null,
    costOfEquity: number | null,
    operatingDays: number,
    purchasePrice: number,
    averageEarnings: number | null,
    interestRateMargin: number | null,
    baseRate?: number,
};


export type TDcfState = {
    dcfValueData: TDcfValue | null;
    loadingError: Error | null;
    loading: boolean;
};

export type TDcfValue = {
    dcfValue: number | null;
    calculatedImoCount: number | null;
    imoCount: number | null;
    coveragePercentage: number | null;
};

// Slice name in the ...Slice.ts file
export const DCF = 'Dcf';

// Action name in ...Slice.ts file that will be called from component
export const GET_DCF_VALUE = `${DCF}/getDcfValueRequestAction`;
export const GET_VESSEL_DCF = `${DCF}/getVesselDcfRequestAction`;
export const GET_SUMMARY_DCF = `${DCF}/getSummaryDcfRequestAction`;